// Локальный маппинг темы диалога: admin не переиспользует partner/site
// локализацию, здесь нет i18n (см. соседние feature: refunds typeLabel).
export const topicLabel: Record<string, string> = {
  PURCHASE: "Покупка",
  ACCESS: "Доступ",
  PLAYBACK: "Воспроизведение",
  PAYMENT: "Оплата",
  REFUND: "Возврат",
  ACCOUNT: "Аккаунт",
  OTHER: "Другое",
};

export const topicOptions = Object.entries(topicLabel).map(
  ([value, label]) => ({ value, label })
);
